import React from 'react';

const Contacts = () => {
  return (
    <div className='mb-10 text-center mx-12' >
        <h2 className='text-5xl font-extrabold font-mono mb-7 py-5 sm:text-7xl'><span className='interested lg:text-7xl'> Interested ?</span> Let's Get In Touch !</h2>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://drive.google.com/file/d/10Ak7K_e12hOmhex3yVOSv_RErz4PvUn6/view?usp=sharing"
          className="bg-transparent border rounded-full px-16 py-5 hover:bg-gray-800 inline-block text-center"
        >
  View & Download Resume
</a>
    </div>

  )
}

export default Contacts;